import React from "react";
import { alpha, useTheme } from "@mui/material";
import { TranscriptMatch } from "./useTranscriptSearch";

interface HighlightedTextProps {
  text: string;
  matches: TranscriptMatch[];
  currentMatchOffset?: number;
  highlightColor?: string;
  activeHighlightColor?: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  matches,
  currentMatchOffset,
  highlightColor,
  activeHighlightColor,
}) => {
  const theme = useTheme();

  if (matches.length === 0) return <>{text}</>;

  const defaultHighlight = highlightColor ?? alpha(theme.palette.warning.light, 0.4);
  const defaultActive = activeHighlightColor ?? alpha(theme.palette.warning.main, 0.7);

  const sorted = [...matches].sort((a, b) => a.startOffset - b.startOffset);
  const fragments: React.ReactNode[] = [];
  let cursor = 0;

  sorted.forEach((match, i) => {
    if (match.startOffset > cursor) {
      fragments.push(text.slice(cursor, match.startOffset));
    }
    const end = match.startOffset + match.length;
    const isActive = match.startOffset === currentMatchOffset;
    fragments.push(
      <mark
        key={i}
        style={{
          backgroundColor: isActive ? defaultActive : defaultHighlight,
          color: "inherit",
          borderRadius: 2,
          padding: "0 1px",
        }}
      >
        {text.slice(match.startOffset, end)}
      </mark>
    );
    cursor = end;
  });

  if (cursor < text.length) {
    fragments.push(text.slice(cursor));
  }

  return <>{fragments}</>;
};
